import { FOUNDATION_BUNKIE_BOARD_NAME, PRODUCT_CODES } from '@/config/globals'
import { isPillowSku } from '@saatva-bits/pattern-library.modules.cart'

function getVariant(item = {}) {
    const attributes = item.attributes || item.productAttributes

    if (!attributes) {
        return ''
    }

    return (
        attributes
            .map((attribute) => {
                /** The 'Standard' part of the Queen size pillows is removed in service-cart-checkout.
                 * Here it is added back to maintain consistency with the rest of the pages.
                 */
                if (isPillowSku(item.productCode) && attribute.value.toLowerCase() === 'queen') {
                    return 'Standard/Queen'
                }

                return attribute.value.replace('"', '') // Remove quotes from the value
            })
            .join('/') || null
    )
}

const getItemName = (item) => {
    if (item.productCode === PRODUCT_CODES.foundation){
        return FOUNDATION_BUNKIE_BOARD_NAME
    }

    return item.genericName || item.name
}

function getItemData(item) {
    const variant = getVariant(item)

    return {
        item_id: item.sku,
        item_name: getItemName(item),
        item_category: item.category,
        item_category2: item.subcategory,
        item_variant: variant,
        price: item.price
    }
}

export async function pushConfigureItem(item, previousPrice, newPrice) {
    try {
        window.dataLayer.push({
            event: 'cartUpdated',
            previousPrice,
            newPrice,
            ...getItemData(item)
        })
    } catch (error) {
        console.error(`[Analytics cartUpdated]: ${error}`)
    }
}

export function pushAddToSaveForLater(item) {
    try {
        window.dataLayer.push({
            event: 'add_to_wishlist',
            ecommerce: {
                items: [
                    {
                        ...getItemData(item),
                        quantity: item.quantity
                    }
                ]
            }
        })
    } catch (error) {
        console.error(`[Analytics add_to_wishlist]: ${error}`)
    }
}

export function pushEditCartItem(item) {
    try {
        window.dataLayer.push({
            event: 'editCartItem',
            ...getItemData(item)
        })
    } catch (error) {
        console.error(`[Analytics editCartItem]: ${error}`)
    }
}

export function pushCartAtcClick(item, position = null) {
    try {
        window.dataLayer.push({
            event: 'cartAtcClick',
            ...getItemData(item),
            position
        })
    } catch (error) {
        console.error(`[Analytics cartAtcClick]: ${error}`)
    }
}

// TODO: update with dynamic values based on Bundle Variant data
export function pushCompleteYourBundleStripView() {
    try {
        window.dataLayer.push({
            event: 'view_bundle_strip',
            item_id: 'classic-starter-bundle',
            item_name: 'Saatva Classic Starter Bundle',
            item_category: 'Bundles',
            item_category2: 'Mattresses',
            price: 0,
            quantity: 1,
            location_id: 'cart'
        })
    } catch (error) {
        console.error(`[Analytics view_bundle_strip]: ${error}`)
    }
}


export function pushCartContentsUpdate(cartData) {
    try {
        const products = cartData.items.map((item) => {
            let discount = 0

            if (item.discounts && item.discounts.length > 0) {
                discount = item.discounts.reduce(
                    (a, b) => {
                        return a.amount + b.amount
                    },
                    { amount: 0 }
                )
            }

            return {
                ...getItemData(item),
                quantity: item.quantity,
                brand: 'Saatva Company',
                salePrice: item.price - discount,
                variantUrl: item.variantUrl
            }
        })

        window.dataLayer.push({
            event: 'cartContentsUpdate',
            cartId: cartData.cartId,
            cartContents: {
                cartItems: products
            },
            productImagePaths: cartData.items.map((item) => item.thumbnail),
            _clear: true // Preventing default recursive merge
        })
    } catch (error) {
        console.error(`[Analytics cartContentsUpdate]: ${error}`)
    }
}

export function pushIncompatibleSkus() {
    try {
        window.dataLayer.push({
            event: 'incompatibleSkus'
        })
    } catch (error) {
        console.error(`[Analytics incompatibleSkus]: ${error}`)
    }
}

export function pushSearchViewed(userId) {
    try {
        window.dataLayer.push({
            event: 'Hits Viewed',
            algoliaUserToken: userId
        })
    } catch (error) {
        console.error(`[Analytics Hits Viewed]: ${error}`)
    }
}

export function pushRecoStripVisible(page) {
    try {
        window.dataLayer.push({
            event: 'recoStripVisible',
            recoStripPage: page
        })
    } catch (error) {
        console.error(`[Analytics pushRecoStripVisible]: ${error}`)
    }
}

export function pushDeliveryGroupings(deliveryGroupings = '') {
    if (deliveryGroupings === '') return
    try {
        window.dataLayer.push({
            event: 'deliveryGroupings',
            groupingsPresent: deliveryGroupings
        })
    } catch (error) {
        console.error(`[Analytics pushDeliveryGroupings]: ${error}`)
    }
}

export function pushStrikethroughPricing(discountsSummary = {}) {
    if (Object.keys(discountsSummary).length === 0) return
    const { totalActiveDiscounts, sitewideDiscounts, couponDiscounts, skuLevelDiscounts } = discountsSummary

    if (typeof window !== 'undefined') {
        try {
            window.dataLayer.push({
                event: 'strikethroughPricing',
                totalActiveDiscounts: totalActiveDiscounts,
                activeDiscounts: [...sitewideDiscounts, ...couponDiscounts, ...skuLevelDiscounts],
                timestamp: new Date().toISOString()
            })
        } catch (error) {
            console.error(`[Analytics pushStrikethroughPricing]: ${error}`)
        }
    }
}
